import general from './general';
import {
  AGENT_MODULES,
  AGENT_MODULE_BY_PATH,
  isAgentWorkspacePath,
  resolveAgentModuleFromAgentPath,
} from '../agentModuleRegistry';

export { AGENT_MODULES } from '../agentModuleRegistry';

export { isAgentWorkspacePath, resolveAgentModuleFromAgentPath, AGENT_MODULE_BY_PATH };

export const DEFAULT_AGENT_MODULE_ID = 'general';

/** Registered module modes — one agent per ERP module */
export const AGENT_MODULE_LIST = [general, ...AGENT_MODULES];

export function getAgentModule(moduleId) {
  if (moduleId === 'general') return general;
  return AGENT_MODULES.find((m) => m.id === moduleId) || general;
}

export function resolveAgentModuleFromPath(pathname) {
  const path = String(pathname || '');

  const fromAgentPage = resolveAgentModuleFromAgentPath(path);
  if (fromAgentPage) return fromAgentPage.id;

  const match = AGENT_MODULES.filter((m) => m.routePrefixes?.length)
    .sort((a, b) => {
      const maxA = Math.max(...a.routePrefixes.map((p) => p.length));
      const maxB = Math.max(...b.routePrefixes.map((p) => p.length));
      return maxB - maxA;
    })
    .find((m) =>
      m.routePrefixes.some(
        (prefix) => path === prefix || path.startsWith(`${prefix}/`),
      ),
    );

  return match?.id || DEFAULT_AGENT_MODULE_ID;
}

export function listLicensedAgentModules(hasModuleAccess) {
  return AGENT_MODULE_LIST.filter((m) => {
    if (!m.moduleKey) return true;
    return hasModuleAccess ? hasModuleAccess(m.moduleKey) : true;
  });
}
